import * as React from "react";
import { Container, Row, Col } from 'reactstrap';
import { Icon, Upload, Button, Input, Modal } from 'antd';
import { FileParam, FileType } from "../../APIModels/FileParam";
import FileService from "../../Services/fileService";
import SERVER_URL from '../../Global'
import { blobToSRC, downloadFileBlob } from "../../util/UtilFunction";

export class HandleEditionFileRender extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            user: this.props.user,
            edition: this.props.edition,
            cover: null,
            coverSaved: false,
            pdfSaved: false,
            txtSaved: false,
            fileParam: new FileParam(),
            fileParamPDF: new FileParam(),
            fileParamTXT: new FileParam(),
            file: null,
            filePDF: null,
            fileTXT: null,
            fileList: [],
            fileListPDF: [],
            fileListTXT: [],
            errorMessagge: '',
            errorMessaggePDF: '',
            errorMessaggeTXT: '',
            modalOpen: false,
            modalTitle: '',
            modalId: '',
            modalType: ''
        }

        this.fileService = new FileService(this.state.user);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputPDFChange = this.handleInputPDFChange.bind(this);
        this.handleInputTXTChange = this.handleInputTXTChange.bind(this);
        this.handleupload = this.handleupload.bind(this);
        this.handleuploadPDF = this.handleuploadPDF.bind(this);
        this.handleuploadTXT = this.handleuploadTXT.bind(this);
        this.uploadCoverEdition = this.uploadCoverEdition.bind(this);
        this.uploadPDFEdition = this.uploadPDFEdition.bind(this);
        this.uploadTXTEdition = this.uploadTXTEdition.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
    }

    componentDidMount() {
        if (this.state.edition.files) {
           this.getFileCover()
        }
    }

    componentWillReceiveProps() {
        this.setState({ edition: this.props.edition }, (() => this.getFileCover() ))
    }

    //recupero tra i file dell'edizione il file Cover, PDF e TXT
    async getFileCover() {
        if (!this.state.edition.files) {
            return
        }
        let cover = this.state.edition.files.filter(f => f.type == FileType.Cover)[0];

        if (cover) {
            const imgsPromise = new Promise((resolve) => {
                this.fileService.downloadFile(cover.id)
                    .then(resp => {
                        var reader = blobToSRC(resp.data)
                        reader.onload = async () => {
                            let base64 = reader.result
                            cover.src = base64
                            resolve(cover);
                        };
                    })
            })

            const coverWithSrc = await Promise.all([imgsPromise])
            this.setState({ cover: coverWithSrc })
        }
    }


    downloadFile(id, name, type) {
        this.fileService.downloadFile(id)
            .then(resp => {
                downloadFileBlob(resp.data, name, type)
            })
    }

    //preparo il formData per il fetch in upload() JPG
    uploadCoverEdition() {

        let photo = this.state.file;
        var formData = new FormData();
        let param = this.state.fileParam;

        param.editionId = this.state.edition.id
        param.type = FileType.Cover;
        param.fileName = photo.name;

        formData.append("file", photo)
        formData.append("param", JSON.stringify(param))

        const correctType = photo.type === 'image/jpeg'  || photo.type === 'image/png' || photo.type === 'application/pdf';
        if (!correctType) {
            this.setState({ errorMessagge: 'file not allowed' }, (() => this.removeUpload() ))
            return;
        }

        this.upload(formData, "cover")
    }

    //preparo il formData per il fetch in upload() PDF
    uploadPDFEdition() {
        this.setState({loaderPDF: true})
        let pdf = this.state.filePDF;
        var formData = new FormData();
        let param = this.state.fileParamPDF;

        param.editionId = this.state.edition.id
        param.type = FileType.CompletePdf;
        param.fileName = pdf.name;

        formData.append("file", pdf)
        formData.append("param", JSON.stringify(param))

        const correctType = pdf.type === 'application/pdf';
        if (!correctType) {
            this.setState({ errorMessaggePDF: 'file not allowed' }, (() => this.removeUploadPDF() ))
            return;
        }

        this.upload(formData, "pdf")
    }

    //preparo il formData per il fetch in upload() TXT
    uploadTXTEdition() {
        this.setState({loaderTXT: true})
        let txt = this.state.fileTXT;
        var formData = new FormData();
        let param = this.state.fileParamTXT;

        param.editionId = this.state.edition.id
        param.type = FileType.CompleteTxt;
        param.fileName = txt.name;

        formData.append("file", txt)
        formData.append("param", JSON.stringify(param))

        const correctType = txt.type === 'text/plain';
        if (!correctType) {
            this.setState({ errorMessaggeTXT: 'file not allowed' }, (() => this.removeUploadTXT()))
            return;
        }

        this.upload(formData, "txt")
    }

    //chiamata fetch con form Data per il file e i relativi parametri
    upload(formData, nameofType) {
        fetch(SERVER_URL + 'api/File/Upload', {
            method: "POST",
            headers: {
                Accept: "application/json",
                contentType: 'multipart/form-data',
                authorization: "Bearer " + this.state.user
            },
            body: formData
        }).then(resp => {
            if (resp.ok) {
                if (nameofType == "cover")
                    this.setState({ coverSaved: true }, (() => this.props.fetchEditionById(this.state.edition.id, true)))
                if (nameofType == "pdf")
                    this.setState({ pdfSaved: true, loaderPDF: false }, (() => this.props.fetchEditionById(this.state.edition.id, true)))
                if (nameofType == "txt")
                    this.setState({ txtSaved: true, loaderTXT: false }, (() => this.props.fetchEditionById(this.state.edition.id, true)))
            }
        })
    }

    //delete file, prende id e nome del file da cancellare, in modo da poi 
    //aggiornare lo state
    deleteFile(id, nameFile) {
        this.props.loader(true)
        this.fileService.deleteFile(id)
            .then(resp => {
                this.props.loader(false)
                if (nameFile == "cover")
                    this.setState({ cover: null, fileList: [], coverSaved: false },(() => this.props.fetchEditionById(this.state.edition.id, true)))
                else if (nameFile == "pdfComplete")
                    this.setState({ fileListPDF: [], pdfSaved: false }, (() => this.props.fetchEditionById(this.state.edition.id, true)))
                else if (nameFile == "txtComplete")
                    this.setState({ fileListTXT: [], txtSaved: false }, (() => this.props.fetchEditionById(this.state.edition.id, true)))

                this.setState({ modalOpen: false, modalTitle: '', modalId: null })
            })
            .catch(err => {
                this.props.loader(false)
                console.log(err)
            })
    }

    handleInputChange({ target }) {
        const value = target.value;
        const name = target.name;
        this.setState(prevState => ({
            fileParam: {
                ...prevState.file,
                [name]: value
            },
            coverSaved: false
        }))
    }

    handleInputPDFChange({ target }) {
        const value = target.value;
        const name = target.name;
        this.setState(prevState => ({
            fileParamPDF: {
                ...prevState.file,
                [name]: value
            },
            pdfSaved: false
        }))
    }

    handleInputTXTChange({ target }) {
        const value = target.value;
        const name = target.name;
        this.setState(prevState => ({
            fileParamTXT: {
                ...prevState.file,
                [name]: value
            },
            txtSaved: false
        }))
    }

    handleupload(e) {
        let file = e.file;
        let fileList = e.fileList;
        fileList = fileList.slice(-1);
        this.setState({ file: file, fileList: fileList, errorMessagge: '' })
    }

    handleuploadPDF(e) {
        let file = e.file;
        let fileList = e.fileList
        fileList = fileList.slice(-1);
        this.setState({ filePDF: file, fileListPDF: fileList, errorMessaggePDF: '' })
    }

    handleuploadTXT(e) {
        let file = e.file;
        let fileList = e.fileList
        fileList = fileList.slice(-1);
        this.setState({ fileTXT: file, fileListTXT: fileList, errorMessaggeTXT: '' })
    }

    removeUpload() {
        this.setState({ file: null, fileList: [] })
    }

    removeUploadPDF() {
        this.setState({ filePDF: null, fileListPDF: [] })
    }

    removeUploadTXT() {
        this.setState({ fileTXT: null, fileListTXT: [] })
    }

    setModal(value, title, id, type) {
        this.setState({ modalOpen: value, modalTitle: title, modalId: id, modalType: type })
    }

    handleCancel() {
        this.setState({ modalOpen: false, modalTitle: '', modalId: null })
    }

    backToEditions() {
        return window.open('/archive', '_self')
    }

    render() {
        //props Upload 
        const props = {
            beforeUpload: (file) => {
                return false; //serve per rimuovere la action
            },            
        };

        let modal =
            <Modal title={'Delete edition n° ' + this.state.modalTitle} visible={this.state.modalOpen} onOk={() => this.deleteFile(this.state.modalId, this.state.modalType)} onCancel={() => this.handleCancel()}>
                <p>Delete {this.state.modalType} of edition number: {this.state.modalTitle}?</p>
            </Modal>

        let cover, pdfComplete, txtComplete;
        if(this.state.edition.files){
            cover = this.state.edition.files.filter(f => f.type == FileType.Cover)[0];
            pdfComplete = this.state.edition.files.filter(f => f.type == FileType.CompletePdf)[0];
            txtComplete = this.state.edition.files.filter(f => f.type == FileType.CompleteTxt)[0];
        }


        return (
            <Row style={{ width: '100%' }}>
                <Col style={{ minHeight: '50vh' }} sm='12'>
                    <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                        <div className="wizardBackground createCat" style={{ height: 'inherit' }}>
                            <div className="modifyHrBox" style={{ width: '100%' }}>
                                <div className={"modifyHr" + this.state.coverSaved} style={{ width: '100%' }}>
                                    <h3 style={{ width: 'auto', fontSize: 22 }}>Cover Edition:</h3>
                                    {/*Cover*/}
                                    {!cover ? (
                                        //Cover Add
                                        <Row className="p-3">
                                            <Col sm="2">
                                                <Upload accept=".png, .jpg, .pdf" onChange={this.handleupload} fileList={this.state.fileList} {...props}>
                                                    <Button > <Icon type="upload" /> Upload</Button>
                                                </Upload>
                                                {this.state.errorMessagge && <p style={{ color: "indianred", margin: "10px 0 0 0" }}>{this.state.errorMessagge}</p>}
                                            </Col>
                                            <Col sm="4">
                                                <Input type="text" name="description" placeholder="Description" value={this.state.fileParam.description} onChange={this.handleInputChange} />
                                            </Col> 
                                            <Col sm="6">
                                                <Button disabled={this.state.file == null} className={this.state.file != null ? 'fmk_button_to_save': ''} onClick={this.uploadCoverEdition}>Save</Button>
                                            </Col>
                                        </Row>
                                    ) : (
                                            //Cover Update
                                            <Row className="align-items-center py-2">
                                                <Col sm="2">
                                                    <div style={{ width: '100%', display: 'inline-flex' }}>
                                                        <h4 style={{ width: 'auto' }}> Cover edition:</h4>
                                                    </div>
                                                    <p>{cover.fileName}</p>
                                                </Col>
                                                <Col sm="6">
                                                    <div style={{ width: '100%', display: 'inline-flex' }}>
                                                        <h4 style={{ width: 'auto' }}>Description:</h4>
                                                    </div>
                                                    <p>{cover.description}</p>
                                                </Col>
                                                <Col sm="4">
                                                    <Button className="mr-4" onClick={() => this.downloadFile(cover.id, cover.fileName, "image/jpg")}>Download</Button>
                                                    <Button onClick={() => this.setModal(true, this.state.edition.number, cover.id, "cover")}>Delete</Button>
                                                </Col>
                                                <Col sm="2">
                                                    {(cover.src) && (
                                                        <img src={cover.src} style={{maxHeight: 200, objectFit: 'cover'}} />
                                                    )}
                                                </Col>
                                            </Row>
                                    )}
                                </div>
                                {/*PDFCOMPLETE*/}
                                <div className={"mt-4 modifyHr" + this.state.pdfSaved} style={{ width: '100%' }}>
                                    <h3 style={{ width: 'auto', fontSize: 22 }}>PDF Edition:</h3>
                                    { !pdfComplete ? (
                                            //PDF Add
                                            <Row className="p-3">
                                                <Col sm="2">
                                                <Upload accept=".pdf" onChange={this.handleuploadPDF} fileList={this.state.fileListPDF} {...props}>
                                                        <Button > <Icon type="upload" /> Upload</Button>
                                                    </Upload>
                                                    {this.state.errorMessaggePDF && <p style={{ color: "indianred", margin: "10px 0 0 0" }}>{this.state.errorMessaggePDF}</p>}
                                                </Col>
                                                <Col sm="4">
                                                    <Input type="text" name="description" placeholder="Description" value={this.state.fileParamPDF.description} onChange={this.handleInputPDFChange} />
                                                </Col>
                                                <Col sm="6">
                                                    {this.state.loaderPDF ? (
                                                        <Icon type="loading" />
                                                    ) : (
                                                        <Button disabled={this.state.filePDF == null} onClick={this.uploadPDFEdition}>Save</Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        ) : (
                                            //PDF Update
                                            <Row className="align-items-center py-2">
                                                <Col sm="4">
                                                    <div style={{ width: '100%', display: 'inline-flex' }}>
                                                        <h4 style={{ width: 'auto' }}> Pdf edition:</h4>
                                                    </div>
                                                    <p>{pdfComplete.fileName}</p>
                                                </Col>
                                                <Col sm="4">
                                                    <div style={{ width: '100%', display: 'inline-flex' }}>
                                                        <h4 style={{ width: 'auto' }}>Description:</h4>
                                                    </div>
                                                    <p>{pdfComplete.description}</p>
                                                </Col>
                                                <Col sm="4">
                                                    <Button className="mr-4" onClick={() => this.downloadFile(pdfComplete.id, pdfComplete.fileName, "application/pdf")}>Download</Button>
                                                    <Button onClick={() => this.setModal(true, this.state.edition.number, pdfComplete.id, "pdfComplete")}>Delete</Button>
                                                </Col>
                                            </Row>
                                        )}
                                </div>
                                {/*TXT*/}
                                <div className={"mt-4 modifyHr" + this.state.txtSaved} style={{ width: '100%' }}>
                                    <h3 style={{ width: 'auto', fontSize: 22 }}>Text Edition:</h3>
                                    {!txtComplete ? (
                                        //TXT Add
                                        <Row className="p-3">
                                            <Col sm="2">
                                                <Upload accept=".txt" onChange={this.handleuploadTXT} fileList={this.state.fileListTXT} {...props}>
                                                    <Button > <Icon type="upload" /> Upload</Button>
                                                </Upload>
                                                {this.state.errorMessaggeTXT && <p style={{ color: "indianred", margin: "10px 0 0 0" }}>{this.state.errorMessaggeTXT}</p>}
                                            </Col>
                                            <Col sm="4">
                                                <Input type="text" name="description" placeholder="Description" value={this.state.fileParamTXT.description} onChange={this.handleInputTXTChange} />
                                            </Col>
                                            <Col sm="6">
                                                {this.state.loaderTXT ? (
                                                        <Icon type="loading" />
                                                    ) : (
                                                        <Button disabled={this.state.fileTXT == null} onClick={this.uploadTXTEdition}>Save</Button>
                                                    )}
                                            </Col>
                                        </Row>
                                    ) : (
                                        //PDF Update
                                        <Row className="align-items-center py-2">
                                            <Col sm="4">
                                                <div style={{ width: '100%', display: 'inline-flex' }}>
                                                    <h4 style={{ width: 'auto' }}> Text edition:</h4>
                                                </div>
                                                <p>{txtComplete.fileName}</p>
                                            </Col>
                                            <Col sm="4">
                                                <div style={{ width: '100%', display: 'inline-flex' }}>
                                                    <h4 style={{ width: 'auto' }}>Description:</h4>
                                                </div>
                                                <p>{txtComplete.description}</p>
                                            </Col>
                                            <Col sm="4">
                                                <Button className="mr-4" onClick={() => this.downloadFile(txtComplete.id, txtComplete.fileName, "text/plain")}>Download</Button>
                                                <Button onClick={() => this.setModal(true, this.state.edition.number, txtComplete.id, "txtComplete")}>Delete</Button>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                                
                            </div>
                            <div className="d-flex justify-content-center position-relative mb-5" style={{ top: 10 }}>
                                    <Button className="saveButtonHrWizard" onClick={() => this.backToEditions() } icon="caret-left" >Back to editions</Button>
                            </div>
                        </div>
                    </div>
                </Col>
                {modal}
            </Row>
        )

    }
}



// WEBPACK FOOTER //
// ./src/FileMaker/Editions/HandleEditionFileRender.js